import { render } from "./AISettings.vue?vue&type=template&id=54133c6c&scoped=true"
import script from "./AISettings.vue?vue&type=script&lang=js"
export * from "./AISettings.vue?vue&type=script&lang=js"

import "./AISettings.vue?vue&type=style&index=0&id=54133c6c&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54133c6c"]])

export default __exports__